export const branchesApi = {

    getAll () {
        return axios.get(`/api/branches`)
    },

}
